import React from 'react';
import FAQ from '~/App/shared/components/FAQ';
import styled from 'styled-components';
import { mq } from '@kvdbil/components';

const Container = styled.div`
  margin-top: -1px;
  background: ${({ theme }) => theme.colors.background.gray};
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${mq('tablet')} {
    margin-top: 0;
  }
`;

const HelpPage = () => {
  return (
    <Container>
      <FAQ />
    </Container>
  );
};

export default HelpPage;
